export class GanttBarGeometry
{
    constructor (public left: number, public width: number)
    {
    }
}
